/**
 * NeverLeafs, Customer Context
 * =============================
 * Wat de bezoeker in de keuzehulp aan Herman vertelt, gaat mee naar de rest
 * van de webshop. Zonder dit doet de site alsof dat gesprek nooit heeft
 * plaatsgevonden: je vertelt dat je iets tropisch van 180 cm zoekt voor de
 * woonkamer, en de collectiepagina begint weer bij nul.
 *
 * Wat het doet:
 *  - bewaart het profiel in een first-party cookie plus localStorage
 *  - toont een balk met wat er bekend is, aanpasbaar en wisbaar
 *  - zet op collectiepagina's de passende planten vooraan
 *  - zet op de PDP een regel of dit product bij het gesprek past
 *
 * Het verbergt nooit producten. Wat niet past zakt naar beneden, het
 * verdwijnt niet: een bezoeker die iets anders wil moet dat kunnen vinden.
 */
(function () {
  'use strict';

  var COOKIE = 'nlf_ctx';
  var STORE = 'nlf_ctx_profile';
  var COOKIE_DAYS = 90;
  // Vanaf welke score een kaart het merkje "past bij je gesprek" verdient.
  // Zie score() voor de punten. Zes betekent in de praktijk: de genoemde
  // plantsoort erbij, of de gevraagde hoogte plus stijl of budget.
  var MARK_THRESHOLD = 6;

  // Zelfde indeling als getStyle() in keuzehulp/api/sync-catalog.php. Staat
  // hier los omdat de shop geen toegang heeft tot die catalogus; wijkt die
  // lijst daar af, pas hem hier ook aan.
  var STIJL = {
    tropisch: ['strelitzia', 'monstera', 'philodendron', 'philondendron', 'kentia', 'areca', 'bananen', 'palm', 'varen', 'dracaena', 'rubberboom', 'yucca'],
    mediterraan: ['olijf', 'eucalyptus', 'agave', 'sinaasappel'],
    klassiek: ['bloesem', 'rozen', 'camelia', 'esdoorn']
  };

  // ===== opslag =====

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      expires = '; expires=' + d.toUTCString();
    }
    // Op .neverleafs.nl zodat keuzehulp.neverleafs.nl hem ook ziet.
    var domain = location.hostname.indexOf('neverleafs.') !== -1
      ? '; domain=.' + location.hostname.split('.').slice(-2).join('.')
      : '';
    document.cookie = name + '=' + encodeURIComponent(value) + expires + domain + '; path=/; SameSite=Lax';
  }

  function clearCookie(name) {
    writeCookie(name, '', -1);
  }

  function load() {
    var raw = null;
    try { raw = localStorage.getItem(STORE); } catch (e) { /* private mode */ }
    if (!raw) raw = readCookie(COOKIE);
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      return (parsed && typeof parsed === 'object' && Object.keys(parsed).length) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function save(profile) {
    var json = JSON.stringify(profile);
    try { localStorage.setItem(STORE, json); } catch (e) {}
    writeCookie(COOKIE, json, COOKIE_DAYS);
  }

  function erase() {
    try { localStorage.removeItem(STORE); } catch (e) {}
    clearCookie(COOKIE);
    profile = null;
    document.querySelectorAll('.nlf-ctx-bar, .nlf-ctx-home, .nlf-ctx-top').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.nlf-ctx-hit').forEach(function (el) { el.classList.remove('nlf-ctx-hit'); });
    document.querySelectorAll('.nlf-ctx-note').forEach(function (el) { el.remove(); });
    restoreGridOrder();
    var check = document.querySelector('.nlf-check');
    if (check) { check.remove(); applyToProduct(); }
    track('context_erase', {});
  }

  var profile = load();

  function track(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'nlf_' + event }, data || {}));
    } catch (e) {}
  }

  // ===== profiel in gewone taal =====

  // Alles behalve de ruimte. De kop zegt al "Voor je kantoor", dus dan hoeft
  // "kantoor" er niet nog een keer onder te staan.
  function details(p) {
    var parts = summary(p);
    if (p.ruimte && parts[0] === p.ruimte) parts.shift();
    return parts;
  }

  // Hoeveel weet Herman echt. Eén los woord is te weinig om de halve
  // homepage voor opzij te schuiven.
  function richness(p) {
    if (!p) return 0;
    var n = 0;
    ['ruimte', 'stijl', 'budget_max', 'buiten'].forEach(function (k) { if (p[k]) n++; });
    if (p.hoogte_min || p.hoogte_max) n++;
    if (p.soorten && p.soorten.length) n++;
    return n;
  }

  // De naam staat bewust niet in summary(): die hoort in de aanhef, niet in
  // het rijtje kenmerken. "kantoor · Jermaya · tropisch" leest als een dossier.
  var PLEK_TEKST = {
    hoek: 'in een hoek', naast_bank: 'naast de bank', op_meubel: 'op een kast',
    voor_raam: 'voor het raam', entree: 'in de entree', balie: 'bij de balie',
    etalage: 'in de etalage'
  };

  function summary(p) {
    var parts = [];
    if (p.ruimte) parts.push(p.ruimte);
    if (p.plek && PLEK_TEKST[p.plek]) parts.push(PLEK_TEKST[p.plek]);
    if (p.stijl) parts.push(p.stijl);
    // 400 is de bovengrens in de code, geen wens van de bezoeker. Die hoort
    // hier niet te staan; dan is "vanaf 170 cm" wat hij bedoelde.
    if (p.hoogte_min && p.hoogte_max >= 400) parts.push('vanaf ' + p.hoogte_min + ' cm');
    else if (p.hoogte_min && p.hoogte_max) parts.push(p.hoogte_min + ' tot ' + p.hoogte_max + ' cm');
    else if (p.hoogte_max) parts.push('tot ' + p.hoogte_max + ' cm');
    else if (p.hoogte_min) parts.push('vanaf ' + p.hoogte_min + ' cm');
    if (p.budget_max) parts.push('tot €' + p.budget_max);
    if (p.soorten && p.soorten.length) parts.push(p.soorten.slice(0, 3).join(', '));
    if (p.buiten) parts.push('voor buiten');
    return parts;
  }

  // ===== producten lezen uit het grid =====

  function heightOf(card) {
    var attr = card.getAttribute('data-nlf-height');
    if (attr) return parseInt(attr, 10);
    var titleEl = card.querySelector('.nhp-product-card__title');
    var text = titleEl ? titleEl.textContent : card.textContent;
    var m = /(\d{2,3})\s*cm/i.exec(text || '');
    return m ? parseInt(m[1], 10) : null;
  }

  function priceOf(card) {
    var attr = card.getAttribute('data-nlf-price');
    if (attr) return parseFloat(attr);
    var priceEl = card.querySelector('.nhp-product-card__price');
    if (!priceEl) return null;
    // "€112,95" en "€ 1.112,95" moeten allebei goed gaan.
    var raw = priceEl.textContent.replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    var val = parseFloat(raw);
    return isNaN(val) ? null : val;
  }

  function styleOf(card) {
    var attr = card.getAttribute('data-nlf-style');
    if (attr) return attr;
    var titleEl = card.querySelector('.nhp-product-card__title');
    var t = (titleEl ? titleEl.textContent : card.textContent || '').toLowerCase();
    for (var key in STIJL) {
      for (var i = 0; i < STIJL[key].length; i++) {
        if (t.indexOf(STIJL[key][i]) !== -1) return key;
      }
    }
    return 'modern';
  }

  function titleOf(card) {
    var titleEl = card.querySelector('.nhp-product-card__title');
    return (titleEl ? titleEl.textContent : '').toLowerCase();
  }

  /**
   * Hoe goed past dit product bij het gesprek. Hoger is beter, 0 is neutraal.
   * Bewust grof: dit is een volgorde, geen ranglijst die iets moet bewijzen.
   */
  /**
   * Scoren op losse velden, zodat dezelfde regels gelden voor een kaart in het
   * grid en voor een product uit de catalogus dat nog op een volgende pagina
   * staat. Eén bron van waarheid, anders krijgt de bezoeker op de collectie een
   * andere uitkomst dan bovenaan.
   */
  function scoreVelden(h, b, prijs, titel, stijl, p) {
    var s = 0;
    var reasons = [];

    if (h && (p.hoogte_min || p.hoogte_max)) {
      var min = p.hoogte_min || 0;
      var max = p.hoogte_max || 999;
      if (h >= min && h <= max) { s += 3; reasons.push(h + ' cm'); }
      else if (h >= min - 20 && h <= max + 20) { s += 1; }
      else { s -= 2; }
    }

    if (b && p.breedte_max) {
      if (b <= p.breedte_max) { s += 2; reasons.push(b + ' cm breed'); }
      else { s -= 3; }
    }

    if (p.stijl && stijl === p.stijl) { s += 2; reasons.push(p.stijl); }

    if (prijs && p.budget_max) {
      if (prijs <= p.budget_max) { s += 2; reasons.push('binnen budget'); }
      else if (prijs <= p.budget_max * 1.15) { s += 0; }
      else { s -= 2; }
    }

    if (p.soorten && p.soorten.length) {
      var t = (titel || '').toLowerCase();
      for (var i = 0; i < p.soorten.length; i++) {
        var soort = String(p.soorten[i]).toLowerCase().trim();
        if (soort && t.indexOf(soort) !== -1) { s += 4; reasons.unshift(soort); break; }
      }
    }

    return { score: s, reasons: reasons };
  }

  function score(card, p) {
    return scoreVelden(heightOf(card), null, priceOf(card), titleOf(card), styleOf(card), p);
  }

  // ===== de hele collectie, niet alleen deze pagina =====
  //
  // Het grid toont 24 producten van de 61. Alleen die 24 sorteren betekent dat
  // de beste match op pagina twee onzichtbaar blijft, terwijl de balk wel
  // beweert dat het beste vooraan staat. Daarom halen we de hele collectie op
  // en zetten we de treffers die hier niet staan erboven.
  //
  // De collectie-JSON is same-origin. De maten komen uit de catalogus van de
  // keuzehulp, want hoogte en breedte staan niet in die JSON.

  function collectieHandle() {
    var m = /\/collections\/([^\/?#]+)/.exec(location.pathname);
    return (m && m[1] !== 'all') ? m[1] : (m ? 'all' : null);
  }

  function handleVanUrl(u) {
    var m = /\/products\/([^\/?#]+)/.exec(u || '');
    return m ? m[1] : null;
  }

  function haalCollectie(klaar) {
    var h = collectieHandle();
    if (!h) return klaar(null, null);
    var pad = '/collections/' + h + '/products.json?limit=250';
    Promise.all([
      fetch(pad).then(function (r) { return r.json(); }).catch(function () { return null; }),
      fetch('https://keuzehulp.neverleafs.nl/api/catalog.php').then(function (r) { return r.json(); }).catch(function () { return null; })
    ]).then(function (uit) {
      klaar(uit[0] && uit[0].products ? uit[0].products : null, Array.isArray(uit[1]) ? uit[1] : null);
    }).catch(function () { klaar(null, null); });
  }

  function cmUit(v) {
    var m = /(\d{2,3})/.exec(String(v || ''));
    return m ? parseInt(m[1], 10) : null;
  }

  function prijsUit(v) {
    var n = parseFloat(String(v || '').replace(/[^\d.,]/g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  /** Welke producten staan al in het grid, zodat we niets dubbel tonen. */
  function zichtbareHandles() {
    var uit = {};
    document.querySelectorAll('.rd-col__grid a[href*="/products/"]').forEach(function (a) {
      var h = handleVanUrl(a.getAttribute('href'));
      if (h) uit[h] = true;
    });
    return uit;
  }

  /** De producttitels dragen een verkoopstaart achter een streepje: "Monstera
   *  kunstplant 180 cm - Tropisch Zuiders gevoel". Op een kaart kapte die staart
   *  af tot "... - Tropis...", en dan staat er een half woord waar de maat had
   *  moeten staan. De kern voor het streepje zegt alles wat hier telt. */
  function kortTitel(t) {
    var heel = String(t || '');
    var kern = heel.split(/\s+[\u2013\u2014-]\s+/)[0].trim();
    return kern.length >= 8 ? kern : heel;
  }

  /**
   * Het grid werd beoordeeld op wat er in de kaart staat (hoogte, prijs, titel),
   * de telling in de balk op de catalogus met de metavelden erbij. Twee
   * beoordelaars, dus twee uitkomsten: de balk zei twaalf en in het grid stonden
   * er drie gemerkt. Zodra de catalogus binnen is beoordelen we het grid
   * opnieuw met diezelfde cijfers, zodat er maar een waarheid is.
   */
  function hermarkeerGrid(scoreOp) {
    var grid = document.querySelector('.rd-col__grid');
    if (!grid) return 0;

    var kaarten = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.nodeType === 1;
    });
    if (kaarten.length < 2) return 0;

    var scored = kaarten.map(function (card, i) {
      var a = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
      var h = a ? handleVanUrl(a.getAttribute('href')) : null;
      var uit = (h && scoreOp[h]) || { score: 0, reasons: [] };
      return { card: card, score: uit.score, reasons: uit.reasons, i: i };
    });
    if (!scored.some(function (x) { return x.score > 0; })) return 0;

    scored.sort(function (a, b) { return b.score - a.score || a.i - b.i; });
    scored.forEach(function (x) { grid.appendChild(x.card); });

    var marked = 0;
    scored.forEach(function (x) {
      x.card.classList.remove('nlf-ctx-hit');
      var oud = x.card.querySelector('.nlf-ctx-note');
      if (oud) oud.remove();
      if (x.score >= MARK_THRESHOLD && x.reasons.length >= 2) {
        marked++;
        x.card.classList.add('nlf-ctx-hit');
        var note = document.createElement('span');
        note.className = 'nlf-ctx-note';
        note.textContent = 'Past bij je gesprek: ' + x.reasons.slice(0, 2).join(', ');
        x.card.appendChild(note);
      }
    });
    return marked;
  }

  function toonCollectieTreffers(p) {
    if (document.querySelector('.nlf-ctx-top')) return;
    haalCollectie(function (producten, catalogus) {
      if (!producten || !producten.length) return;

      var perHandle = {};
      (catalogus || []).forEach(function (c) {
        var h = handleVanUrl(c.url);
        if (h) perHandle[h] = c;
      });

      var gescoord = producten.map(function (pr) {
        var c = perHandle[pr.handle] || {};
        var prijs = prijsUit(pr.variants && pr.variants[0] ? pr.variants[0].price : null);
        var hoogte = cmUit(c.height) || cmUit(pr.title);
        var breedte = c.breedte || null;
        var stijl = c.style || null;
        var r = scoreVelden(hoogte, breedte, prijs, pr.title, stijl, p);
        return {
          handle: pr.handle, titel: pr.title, prijs: prijs,
          img: (c.img_cut || c.img || (pr.images && pr.images[0] ? pr.images[0].src : '')),
          score: r.score, reasons: r.reasons
        };
      });

      var goed = gescoord.filter(function (x) {
        return x.score >= MARK_THRESHOLD && x.reasons.length >= 2;
      }).sort(function (a, b) { return b.score - a.score; });

      // Alle treffers tonen, ook die al in het grid staan. Eerder liet ik alleen
      // de onzichtbare zien, en dan zei de balk "2 passen hierbij" terwijl je er
      // een zag. Dat telt niet op voor de bezoeker.
      // Eerst het grid opnieuw beoordelen met deze cijfers, daarna pas kijken
      // wat er zichtbaar is: de sortering verandert immers wat er vooraan staat.
      var scoreOp = {};
      gescoord.forEach(function (x) { scoreOp[x.handle] = { score: x.score, reasons: x.reasons }; });
      hermarkeerGrid(scoreOp);

      var zicht = zichtbareHandles();
      var extra = goed.slice(0, 4);

      werkBalkBij(goed.length, producten.length);
      if (!extra.length) return;

      var el = document.createElement('div');
      el.className = 'nlf-ctx-top';
      // De kopregel zei eerst hoeveel er pasten, en dat stond dan twee keer
      // boven elkaar met het merkje. Nu zegt hij waaróm juist deze hier staan.
      el.innerHTML =
        '<span class="nlf-ctx-top__kop">Het dichtst bij wat je vertelde</span>' +
        '<div class="nlf-ctx-top__rij">' +
          extra.map(function (x) {
            return '<a class="nlf-ctx-top__kaart" href="/products/' + encodeURIComponent(x.handle) + '">' +
              (x.img ? '<img class="nlf-ctx-top__img" src="' + escapeHTML(x.img) + '" alt="" loading="lazy">' : '<span class="nlf-ctx-top__img"></span>') +
              '<span class="nlf-ctx-top__tekst">' +
                '<span class="nlf-ctx-top__titel">' + escapeHTML(kortTitel(x.titel)) + '</span>' +
                '<span class="nlf-ctx-top__reden">' + escapeHTML(x.reasons.slice(0, 2).join(', ')) + '</span>' +
              '</span>' +
              // Prijs en vindplaats onder elkaar aan de rechterkant: dat leest
              // als een productregel, terwijl vier losse dingen op een rij
              // eruitzagen als een dashboard.
              '<span class="nlf-ctx-top__rechts">' +
                (x.prijs ? '<span class="nlf-ctx-top__prijs">&euro;' + String(x.prijs.toFixed(2)).replace('.', ',') + '</span>' : '') +
                '<span class="nlf-ctx-top__hier' + (zicht[x.handle] ? '' : ' is-ver') + '">' +
                  (zicht[x.handle] ? 'staat hieronder' : 'verderop') + '</span>' +
              '</span>' +
              '<svg class="nlf-ctx-top__pijl" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
            '</a>';
          }).join('') +
        '</div>';

      // In de balk zelf. Eén kaart op een leeg veld ziet eruit als een fout,
      // binnen het paneel leest hetzelfde als een aanbeveling.
      var balk = document.querySelector('.nlf-ctx-bar');
      if (balk) balk.appendChild(el);
      else {
        var grid = document.querySelector('.rd-col__grid');
        if (!grid) return;
        grid.parentNode.insertBefore(el, grid);
      }
      track('context_collectie_extra', { getoond: extra.length, treffers: goed.length });
    });
  }

  /** De balk telt over de hele collectie, niet over deze pagina. */
  function werkBalkBij(treffers, totaal) {
    var el = document.querySelector('.nlf-ctx-bar__count');
    if (!el) return;
    // Weet Herman nog bijna niets, dan haalt geen enkel product de drempel en
    // zou hier "niets sluit precies aan" komen te staan. Dat klinkt alsof de
    // winkel niets heeft, terwijl het aan de vraag ligt. Dan liever niets.
    if (richness(profile) < 2) { el.textContent = ''; return; }
    el.classList.toggle('is-leeg', !treffers);
    if (!treffers) el.textContent = 'niets sluit precies aan';
    else if (treffers === 1) el.textContent = '1 van de ' + totaal + ' past hierbij';
    else el.textContent = treffers + ' van de ' + totaal + ' passen hierbij';
  }

  // ===== collectiepagina =====

  var originalOrder = null;

  function restoreGridOrder() {
    if (!originalOrder) return;
    var grid = originalOrder.grid;
    originalOrder.cards.forEach(function (card) { grid.appendChild(card); });
    originalOrder = null;
  }

  function applyToGrid(p) {
    var grid = document.querySelector('.rd-col__grid');
    if (!grid) return 0;

    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.nodeType === 1;
    });
    if (cards.length < 2) return 0;

    if (!originalOrder) originalOrder = { grid: grid, cards: cards.slice() };

    var scored = cards.map(function (card, i) {
      var r = score(card, p);
      return { card: card, score: r.score, reasons: r.reasons, i: i };
    });

    if (!scored.some(function (x) { return x.score > 0; })) return 0;

    // Stabiel sorteren: gelijke score houdt de volgorde van de winkel, zodat
    // de sortering van de collectie zelf niet zomaar overboord gaat.
    scored.sort(function (a, b) { return b.score - a.score || a.i - b.i; });
    scored.forEach(function (x) { grid.appendChild(x.card); });

    // Het merkje is alleen iets waard als het schaars is. Hij vraagt om twee
    // rake punten, bijvoorbeeld de genoemde plantsoort plus de stijl, of de
    // gevraagde hoogte plus het budget. Een kaart die alleen toevallig de
    // goede stijl heeft schuift wel naar voren maar krijgt geen merkje.
    var marked = 0;
    scored.forEach(function (x) {
      x.card.classList.remove('nlf-ctx-hit');
      var old = x.card.querySelector('.nlf-ctx-note');
      if (old) old.remove();
      if (x.score >= MARK_THRESHOLD && x.reasons.length >= 2) {
        marked++;
        x.card.classList.add('nlf-ctx-hit');
        var note = document.createElement('span');
        note.className = 'nlf-ctx-note';
        note.textContent = 'Past bij je gesprek: ' + x.reasons.slice(0, 2).join(', ');
        x.card.appendChild(note);
      }
    });

    return marked;
  }

  // ===== productpagina: de check =====
  //
  // Gezien bij dierapotheker.nl: op de productpagina staat geen chatknop maar
  // de vraag of dít product bij je past. Dat is ook precies de vraag die
  // iemand daar heeft. De eerste versie stuurde je door naar de algemene chat,
  // en dan begon je weer bij nul; daarom staat de check nu in de pagina zelf.
  //
  // De specificaties op deze pagina zijn echte cijfers, hoogte en breedte
  // staan bij elk product. Daar kunnen we dus een hard oordeel op geven in
  // plaats van een vriendelijke zin.
  //
  // Wat de bezoeker hier antwoordt gaat naar hetzelfde profiel als het gesprek
  // met Herman. De check is een tweede manier om dat profiel te vullen, voor
  // wie liever niet chat.


  // Een meetlat, want daar gaat deze kaart over: past de maat.
  var CHECK_ICO = '<svg class="nlf-check__ico" width="14" height="14" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M2 8h20v8H2z"/><path d="M6 8v3M10 8v5M14 8v3M18 8v5"/></svg>';

  function specs() {
    var out = {};
    document.querySelectorAll('.nl-specs-grid .nl-spec').forEach(function (el) {
      var l = el.querySelector('.nl-spec__label');
      var v = el.querySelector('.nl-spec__value');
      if (!l || !v) return;
      var key = l.textContent.replace(/[:\s]+$/, '').trim().toLowerCase();
      out[key] = v.textContent.trim();
    });
    return out;
  }

  function cmOf(text) {
    var m = /(\d{2,3})\s*cm/i.exec(text || '');
    return m ? parseInt(m[1], 10) : null;
  }

  function pdpPrice() {
    var el = document.querySelector('.nl-selected-price, .nl-cta-price, .nl-price-range');
    if (!el) return null;
    var raw = el.textContent.replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    var v = parseFloat(raw);
    return isNaN(v) ? null : v;
  }

  function pdpTitle() {
    var el = document.querySelector('h1.nl-title, .rd-pd__title, .product__title, h1');
    return el ? el.textContent.trim() : '';
  }

  /**
   * Het oordeel per punt. Alleen punten waarover we iets weten: een regel
   * "budget onbekend" helpt niemand.
   */
  function verdict(p) {
    var sp = specs();
    var rows = [];
    var titel = pdpTitle();
    var fake = document.createElement('div');
    fake.innerHTML = '<div class="nhp-product-card__title">' + titel + '</div>';

    var h = cmOf(sp['hoogte']) || heightOf(fake);

    // Staat hij op een kast, dan is de hoogte van een vloerplant het punt, en
    // niet of het getal toevallig binnen de opgegeven marge valt. Twee regels
    // die elkaar tegenspreken is erger dan één regel die klopt.
    var kastConflict = (p.plek === 'op_meubel' && h && h >= 140);

    if (h && !kastConflict && (p.hoogte_min || p.hoogte_max)) {
      var min = p.hoogte_min || 0, max = p.hoogte_max || 999;
      if (h >= min && h <= max) {
        var bereik = (p.hoogte_max && p.hoogte_max >= 400)
          ? 'vanaf ' + p.hoogte_min + ' cm'
          : (p.hoogte_min ? p.hoogte_min + ' tot ' + p.hoogte_max + ' cm' : 'tot ' + p.hoogte_max + ' cm');
        rows.push({ ok: true, tekst: h + ' cm hoog, binnen de ' + bereik + ' die je noemde' });
      } else if (h > max) {
        rows.push({ ok: false, tekst: h + ' cm hoog, dat is ' + (h - max) + ' cm meer dan je zocht' });
      } else {
        rows.push({ ok: false, tekst: h + ' cm hoog, dat is ' + (min - h) + ' cm minder dan je zocht' });
      }
    }

    var b = cmOf(sp['breedte']);
    if (b && p.breedte_max) {
      if (b <= p.breedte_max) rows.push({ ok: true, tekst: b + ' cm breed, past in je ' + p.breedte_max + ' cm' });
      else rows.push({ ok: false, tekst: b + ' cm breed, en je hebt ' + p.breedte_max + ' cm' });
    }

    // Een vloerplant van 180 cm hoort niet op een kast, wat de bezoeker ook
    // over hoogte gezegd heeft. Dit is het enige punt waar de plek harder
    // weegt dan het getal.
    if (kastConflict) {
      rows.push({ ok: false, tekst: 'Dit is een vloerplant van ' + h + ' cm, voor op een kast te fors' });
    } else if (p.plek === 'op_meubel' && h && h <= 60) {
      rows.push({ ok: true, tekst: h + ' cm, dat staat goed op een kast' });
    }

    var prijs = pdpPrice();
    if (prijs && p.budget_max) {
      if (prijs <= p.budget_max) rows.push({ ok: true, tekst: 'Binnen je budget van €' + p.budget_max });
      else rows.push({ ok: false, tekst: '€' + String(prijs).replace('.', ',') + ', boven je budget van €' + p.budget_max });
    }

    if (p.stijl) {
      var st = styleOf(fake);
      rows.push(st === p.stijl
        ? { ok: true, tekst: 'Past bij de ' + p.stijl + 'e stijl die je zocht' }
        : { ok: false, tekst: 'Meer ' + st + ' dan ' + p.stijl });
    }

    // Wat de bezoeker als reden gaf, beantwoord met een echt gegeven van de
    // pagina in plaats van een algemene geruststelling.
    if (p.waarom && (sp['onderhoud'] || sp['levensduur'])) {
      var reden = {
        geen_groene_vingers: 'Je zei dat planten het bij jou niet redden. Deze vraagt alleen ' + (sp['onderhoud'] || 'afstoffen').toLowerCase() + '.',
        donkere_plek: 'Je zocht iets voor een donkere plek. Licht maakt deze niets uit.',
        allergie: 'Je noemde allergie. Geen stuifmeel, geen aarde.',
        weinig_tijd: 'Je hebt er weinig tijd voor. Alleen ' + (sp['onderhoud'] || 'afstoffen').toLowerCase() + '.',
        vaak_weg: 'Je bent vaak weg. Deze staat er over ' + (sp['levensduur'] || '10+ jaar') + ' nog net zo bij.',
        huisdieren: 'Je noemde huisdieren. Niets giftigs, geen aarde om uit te graven.',
        kinderen: 'Je noemde kinderen. Niets giftigs en niets om om te stoten met water erin.',
        zakelijk_onderhoud: 'Zakelijk gezien: alleen ' + (sp['onderhoud'] || 'afstoffen').toLowerCase() + ', en ' + (sp['levensduur'] || '10+ jaar') + ' mee.'
      }[p.waarom];
      if (reden) rows.push({ ok: true, tekst: reden, zacht: true });
    }

    // Alle producten doen mee aan bundelvoordeel, dus vanaf twee is dat een
    // feit dat de bezoeker moet weten in plaats van een verkooppraatje.
    if (p.aantal && p.aantal >= 2) {
      rows.push({ ok: true, zacht: true, tekst: 'Je zoekt er ' + p.aantal + '. Vanaf twee geldt bundelvoordeel.' });
    }

    return rows;
  }

  function verdictTitle(rows, p) {
    var mis = rows.filter(function (r) { return !r.ok; }).length;
    var waar = p.ruimte ? ' in je ' + escapeHTML(p.ruimte) : '';
    if (!rows.length) return 'Ik weet nog te weinig';
    if (!mis) return 'Deze past' + waar;
    if (mis === 1) return 'Past' + waar + ', op één punt na';
    return 'Deze sluit niet aan bij wat je zocht';
  }

  // De vragen. Alleen wat we nog niet weten, en nooit meer dan drie.
  var CHECK_VRAGEN = [
    {
      veld: 'plek', vraag: 'Waar komt hij te staan?',
      opties: [
        { label: 'In een hoek', waarde: 'hoek' },
        { label: 'Naast de bank', waarde: 'naast_bank' },
        { label: 'Op een kast of tafel', waarde: 'op_meubel' },
        { label: 'In de entree', waarde: 'entree' },
        { label: 'Op kantoor', waarde: 'balie' }
      ]
    },
    {
      veld: 'breedte_max', vraag: 'Hoeveel ruimte heb je in de breedte?',
      opties: [
        { label: 'Tot 60 cm', waarde: 60 },
        { label: '60 tot 90 cm', waarde: 90 },
        { label: '90 tot 120 cm', waarde: 120 },
        { label: 'Meer dan 120 cm', waarde: 200 }
      ]
    },
    {
      veld: 'aantal', vraag: 'Zoek je er één of meer?',
      opties: [
        { label: 'Eén', waarde: 1 },
        { label: 'Twee', waarde: 2 },
        { label: 'Drie of meer', waarde: 3 }
      ],
      alleenAls: function (p) { return p && (p.zakelijk || p.plek === 'balie' || p.plek === 'etalage'); }
    },
    {
      veld: 'stijl', vraag: 'Welke sfeer past bij je interieur?',
      opties: [
        { label: 'Tropisch en vol', waarde: 'tropisch' },
        { label: 'Mediterraan en warm', waarde: 'mediterraan' },
        { label: 'Strak en modern', waarde: 'modern' },
        { label: 'Klassiek en zacht', waarde: 'klassiek' }
      ]
    },
    {
      veld: 'budget_max', vraag: 'Wat mag hij ongeveer kosten?',
      opties: [
        { label: 'Tot 90 euro', waarde: 90 },
        { label: '90 tot 120 euro', waarde: 120 },
        { label: 'Mag meer kosten', waarde: 250 }
      ]
    },
    {
      veld: 'waarom', vraag: 'Waarom een kunstplant?',
      opties: [
        { label: 'Planten gaan bij mij dood', waarde: 'geen_groene_vingers' },
        { label: 'Te weinig licht hier', waarde: 'donkere_plek' },
        { label: 'Geen tijd om te verzorgen', waarde: 'weinig_tijd' },
        { label: 'Ik ben vaak weg', waarde: 'vaak_weg' },
        { label: 'Huisdieren of kinderen', waarde: 'huisdieren' }
      ]
    },
    {
      veld: 'hoogte', vraag: 'Hoe hoog mag hij worden?',
      opties: [
        { label: 'Tot 150 cm', waarde: [0, 150] },
        { label: '150 tot 180 cm', waarde: [150, 180] },
        { label: '180 cm of meer', waarde: [180, 400] }
      ]
    }
  ];

  function openVragen(p) {
    var lijst = [];
    CHECK_VRAGEN.forEach(function (v) {
      if (v.alleenAls && !v.alleenAls(p)) return;
      if (v.veld === 'hoogte') { if (!p || (!p.hoogte_min && !p.hoogte_max)) lijst.push(v); }
      else if (!p || !p[v.veld]) lijst.push(v);
    });
    return lijst;
  }

  // Antwoorden van deze check, nog niet opgeslagen: dat gebeurt pas als de
  // bezoeker zegt dat het onthouden mag worden.
  var checkAntwoorden = {};
  var checkStap = 0;
  var checkVragen = [];

  function checkHost() {
    // Onder de fotogalerij, maar IN die kolom en niet ernaast. De pagina is
    // een grid van twee kolommen met de galerij en het koopblok als enige
    // kinderen; er een derde kind tussen zetten maakte de check kolom twee en
    // duwde het hele koopblok naar de rij eronder.
    var gallery = document.querySelector('#nl-gallery, .nl-gallery');
    if (gallery) return { node: gallery, waar: 'in' };
    var anchor = document.querySelector('.nl-specs-details');
    if (anchor) return { node: anchor, waar: 'na' };
    var t = document.querySelector('h1.nl-title, .rd-pd__title, .product__title, h1');
    return t ? { node: t, waar: 'na' } : null;
  }

  function renderCheck(state) {
    var el = document.querySelector('.nlf-check');
    if (!el) {
      var host = checkHost();
      if (!host) return;
      el = document.createElement('div');
      el.className = 'nlf-check';
      if (host.waar === 'in') host.node.appendChild(el);
      else host.node.parentNode.insertBefore(el, host.node.nextSibling);
    }
    el.innerHTML = state.html;
    el.className = 'nlf-check' + (state.modifier || '');
    (state.bind || function () {})(el);
  }

  function checkUitnodiging() {
    var p = profile || {};
    var sp = specs();
    var h = cmOf(sp['hoogte']);
    var b = cmOf(sp['breedte']);
    var n = openVragen(p).length;

    // Zeg iets dat alleen op déze pagina waar is. "Deze is 180 cm hoog en 90 cm
    // breed" is concreter, en klinkt minder als een reclameblok, dan een
    // algemene belofte over persoonlijk advies.
    var maten = (h && b) ? 'Deze is ' + h + ' cm hoog en ' + b + ' cm breed. '
              : (h ? 'Deze is ' + h + ' cm hoog. ' : '');
    var waar = p.ruimte ? 'je ' + p.ruimte : 'jouw ruimte';

    renderCheck({
      html:
        '<strong class="nlf-check__title">Past deze in ' + escapeHTML(waar) + '?</strong>' +
        '<span class="nlf-check__sub">' + escapeHTML(maten) +
          (n === 1 ? 'Eén vraag over je plek' : n + ' vragen over je plek') +
          ' en je weet of dat uitkomt.</span>' +
        '<div class="nlf-check__actions">' +
          '<button type="button" class="nlf-check__btn" data-check="start">Doe de check</button>' +
        '</div>',
      bind: function (el) {
        el.querySelector('[data-check="start"]').addEventListener('click', function () {
          checkAntwoorden = {};
          checkStap = 0;
          checkVragen = openVragen(profile || {});
          track('productcheck_start', { product: pdpTitle().slice(0, 120) });
          if (!checkVragen.length) checkUitslag(); else checkVraag();
        });
      }
    });
  }

  function checkVraag() {
    var v = checkVragen[checkStap];
    if (!v) return checkUitslag();
    var nr = checkStap + 1, van = checkVragen.length;
    renderCheck({
      modifier: ' nlf-check--open',
      html:
        '<div class="nlf-check__head">' +
          '<span class="nlf-check__step">Vraag ' + nr + ' van ' + van + '</span>' +
          '<button type="button" class="nlf-check__close" data-check="stop" aria-label="Check sluiten">&times;</button>' +
        '</div>' +
        '<strong class="nlf-check__title">' + escapeHTML(v.vraag) + '</strong>' +
        '<div class="nlf-check__opts">' +
          v.opties.map(function (o, i) {
            return '<button type="button" class="nlf-check__opt" data-i="' + i + '">' + escapeHTML(o.label) + '</button>';
          }).join('') +
        '</div>',
      bind: function (el) {
        el.querySelectorAll('.nlf-check__opt').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var o = v.opties[parseInt(btn.getAttribute('data-i'), 10)];
            if (v.veld === 'hoogte') {
              checkAntwoorden.hoogte_min = o.waarde[0] || null;
              checkAntwoorden.hoogte_max = o.waarde[1];
              if (!checkAntwoorden.hoogte_min) delete checkAntwoorden.hoogte_min;
            } else {
              checkAntwoorden[v.veld] = o.waarde;
            }
            checkStap++;
            checkVraag();
          });
        });
        el.querySelector('[data-check="stop"]').addEventListener('click', checkUitnodiging);
      }
    });
  }

  function checkUitslag() {
    // Het profiel zoals het nu is, plus wat er zojuist is geantwoord.
    var p = Object.assign({}, profile || {}, checkAntwoorden);
    var rows = verdict(p);
    var mis = rows.filter(function (r) { return !r.ok; });
    var nogNietOpgeslagen = Object.keys(checkAntwoorden).length > 0;

    renderCheck({
      modifier: ' nlf-check--open' + (mis.length ? ' nlf-check--let' : ' nlf-check--goed'),
      html:
        '<div class="nlf-check__head">' +
          '<span class="nlf-check__step">Uitslag</span>' +
          '<button type="button" class="nlf-check__close" data-check="stop" aria-label="Check sluiten">&times;</button>' +
        '</div>' +
        '<strong class="nlf-check__title">' + verdictTitle(rows, p) + '</strong>' +
        (rows.length
          ? '<ul class="nlf-check__rows">' + rows.map(function (r) {
              return '<li class="nlf-check__row' + (r.ok ? '' : ' is-mis') + (r.zacht ? ' is-zacht' : '') + '">' +
                '<span class="nlf-check__mark" aria-hidden="true">' + (r.ok ? '&#10003;' : '&#33;') + '</span>' +
                '<span>' + escapeHTML(r.tekst) + '</span></li>';
            }).join('') + '</ul>'
          : '<p class="nlf-check__sub">Vertel Herman wat meer, dan kan ik dit wel zeggen.</p>') +
        '<div class="nlf-check__actions">' +
          (mis.length
            ? '<a class="nlf-check__btn" href="/collections/kunstplanten">Toon wat wel past</a>'
            : '<button type="button" class="nlf-check__btn" data-check="dicht">Duidelijk, dank je</button>') +
          '<button type="button" class="nlf-check__link" data-check="herman">Vraag het Herman</button>' +
        '</div>' +
        (nogNietOpgeslagen
          ? '<div class="nlf-check__bewaar">Zal ik dit onthouden voor de rest van de site? ' +
            '<button type="button" class="nlf-check__ja" data-check="ja">Ja</button>' +
            '<button type="button" class="nlf-check__link" data-check="nee">Nee, dank je</button></div>'
          : ''),
      bind: function (el) {
        var stop = el.querySelector('[data-check="stop"]');
        if (stop) stop.addEventListener('click', checkUitnodiging);
        var dicht = el.querySelector('[data-check="dicht"]');
        if (dicht) dicht.addEventListener('click', checkUitnodiging);
        el.querySelector('[data-check="herman"]').addEventListener('click', function () {
          if (window.NLStylist) window.NLStylist.open('productcheck');
        });
        var ja = el.querySelector('[data-check="ja"]');
        if (ja) ja.addEventListener('click', function () {
          window.NlfContext.set(checkAntwoorden);
          checkAntwoorden = {};
          track('productcheck_bewaard', {});
          checkUitslag();
        });
        var nee = el.querySelector('[data-check="nee"]');
        if (nee) nee.addEventListener('click', function () {
          var b = el.querySelector('.nlf-check__bewaar');
          if (b) b.remove();
          track('productcheck_niet_bewaard', {});
        });
      }
    });
    track('productcheck_uitslag', { punten: rows.length, mis: mis.length });
  }

  function applyToProduct() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.nlf-check')) return; // nooit twee keer
    // Meteen het oordeel zodra we er iets zinnigs over kunnen zeggen: twee
    // punten, of één punt dat niet klopt. Dat laatste is juist het bericht
    // waar iemand wat aan heeft.
    var rows = profile ? verdict(profile) : [];
    var mis = rows.filter(function (r) { return !r.ok; }).length;
    if (rows.length >= 2 || mis >= 1) checkUitslag();
    else checkUitnodiging();
    track('productcheck_shown', {});
  }

  // ===== de balk =====

  // Wat er onder de samenvatting staat. Niets beweren als er niets gebeurd is:
  // dan liever vragen om het ontbrekende stuk, want daar wordt het beter van.

  /** De kenmerken als losse pillen. Een regel met middenpunten leest als een
   *  uitdraai; losse pillen lezen als een lijstje dat iemand heeft onthouden. */
  function pillenHTML(p) {
    return summary(p).map(function (t) {
      return '<span class="nlf-ctx-bar__pil">' + escapeHTML(t) + '</span>';
    }).join('');
  }

  /** Kort genoeg voor een merkje naast de naam. De telling over de hele
   *  collectie komt van werkBalkBij zodra die binnen is; tot die tijd liever
   *  niets beweren dan een getal dat een tel later verandert. */
  function barCount(p, hitCount) {
    if (!hitCount) return '';
    return hitCount === 1 ? '1 past hierbij' : hitCount + ' passen hierbij';
  }

  /** Weet Herman nog te weinig, dan is "Aanpassen" het verkeerde woord: er valt
   *  nog niets aan te passen, er valt iets toe te voegen. */
  function barKnopTekst(p) {
    return richness(p) < 2 ? 'Meer vertellen' : 'Aanpassen';
  }

  function bar(p, hitCount) {
    var sum = summary(p);
    if (!sum.length) return;

    // Het profiel groeit tijdens het gesprek, dus een balk die er al staat
    // moet bijwerken in plaats van blijven hangen op de eerste versie.
    var existing = document.querySelector('.nlf-ctx-bar');
    if (existing) {
      existing.querySelector('.nlf-ctx-bar__sum').innerHTML = pillenHTML(p);
      var countEl = existing.querySelector('.nlf-ctx-bar__count');
      if (countEl) countEl.textContent = barCount(p, hitCount);
      var knop = existing.querySelector('[data-nlf-ctx="chat"]');
      if (knop) knop.textContent = barKnopTekst(p);
      return;
    }

    var anchor = document.querySelector('.rd-col__grid');
    if (!anchor) return;

    var el = document.createElement('div');
    el.className = 'nlf-ctx-bar';
    el.innerHTML =
      '<div class="nlf-ctx-bar__top">' +
      '<div class="nlf-ctx-bar__text">' +
        '<span class="nlf-ctx-bar__label">' +
          '<img class="nlf-ctx-bar__avatar" src="https://keuzehulp.neverleafs.nl/avatar.png" alt="" loading="lazy">' +
          '<span class="nlf-ctx-bar__wie">' +
            (p.naam ? escapeHTML(p.naam) + ', uit je gesprek met Herman' : 'Uit je gesprek met Herman') +
          '</span>' +
          '<span class="nlf-ctx-bar__count">' + barCount(p, hitCount) + '</span>' +
        '</span>' +
        '<span class="nlf-ctx-bar__sum">' + pillenHTML(p) + '</span>' +
      '</div>' +
      '<div class="nlf-ctx-bar__actions">' +
        '<button type="button" class="nlf-ctx-bar__btn" data-nlf-ctx="chat">' + barKnopTekst(p) + '</button>' +
        '<button type="button" class="nlf-ctx-bar__btn nlf-ctx-bar__btn--erase" data-nlf-ctx="erase">Wissen</button>' +
      '</div>' +
      '</div>';
    anchor.parentNode.insertBefore(el, anchor);

    el.querySelector('[data-nlf-ctx="erase"]').addEventListener('click', function () {
      erase();
      track('context_erase_click', {});
    });
    el.querySelector('[data-nlf-ctx="chat"]').addEventListener('click', function () {
      // De overlay vangt elke keuzehulp-link af, dus dit opent gewoon de chat.
      var opener = document.querySelector('a[href*="keuzehulp.neverleafs.nl"], .nl-fab');
      if (opener) opener.click();
      else window.location.href = 'https://keuzehulp.neverleafs.nl';
    });

    track('context_bar_shown', { fields: Object.keys(p).join(','), hits: hitCount });
  }

  // ===== advies dat doorgaat =====
  // De zwevende knop zegt standaard "Help mij kiezen...". Zodra we weten waar
  // iemand mee bezig is, stelt hij de vraag die op dát moment past. Dat is het
  // verschil tussen een chatknop en een verkoper die meeloopt.
  function adviceLabel(p) {
    if (!p) return null;
    if (/\/products\//.test(location.pathname)) {
      if (p.ruimte) return 'Past deze in je ' + p.ruimte + '?';
      return 'Is dit de juiste maat voor je?';
    }
    if (p.soorten && p.soorten.length) return 'Meer zoals ' + p.soorten[0] + '?';
    if (p.ruimte) return 'Wat past nog meer in je ' + p.ruimte + '?';
    if (p.stijl) return 'Meer in ' + p.stijl + 'e stijl?';
    return null;
  }

  function applyAdviceButton(p) {
    var btn = document.getElementById('nl-float-btn');
    if (!btn) return;
    var label = adviceLabel(p);
    if (!label) return;
    var span = btn.querySelector('span:not(.nl-dot)');
    if (span) span.textContent = label;
    btn.setAttribute('aria-label', label + ' Open de keuzehulp.');
  }

  // ===== persoonlijke start op de homepage =====
  // Niet het hele startscherm omgooien, wel er meteen bovenaan laten zien dat
  // het gesprek nog geldt, met een weg terug naar de planten die erbij passen.
  function applyToHome(p) {
    if (document.querySelector('.nlf-ctx-home')) return;
    var sum = summary(p);
    if (!sum.length) return;
    // Bij één los gegeven ("kantoor") is er niets te personaliseren en ziet het
    // er vooral leeg uit. Dan laten we de gewone homepage met rust.
    if (richness(p) < 2) return;

    var main = document.querySelector('main') || document.body;
    var first = main.firstElementChild;
    if (!first) return;

    // De merkhero is het belangrijkste op deze pagina. Dit blok gaat erboven
    // staan, dus het moet een strook zijn en geen tweede hero. Eén regel,
    // knoppen op dezelfde hoogte.
    var el = document.createElement('section');
    el.className = 'nlf-ctx-home';
    var waar = p.ruimte ? 'je ' + p.ruimte : 'jou';
    var rest = details(p);
    el.innerHTML =
      '<div class="nlf-ctx-home__inner">' +
        '<div class="nlf-ctx-home__text">' +
          '<span class="nlf-ctx-home__eyebrow">' +
            (p.naam ? 'Welkom terug, ' + escapeHTML(p.naam) : 'Verder waar je gebleven was') +
          '</span>' +
          '<h2 class="nlf-ctx-home__title">Voor ' + escapeHTML(waar) +
            (rest.length ? '<span class="nlf-ctx-home__rest">' + escapeHTML(rest.join(' · ')) + '</span>' : '') +
          '</h2>' +
        '</div>' +
        '<div class="nlf-ctx-home__actions">' +
          '<a class="nlf-ctx-home__btn" href="/collections/kunstplanten">Bekijk wat hierbij past</a>' +
          '<button type="button" class="nlf-ctx-home__btn nlf-ctx-home__btn--ghost" data-nlf-ctx="erase">Wissen</button>' +
        '</div>' +
      '</div>';
    main.insertBefore(el, first);
    el.querySelector('[data-nlf-ctx="erase"]').addEventListener('click', function () { erase(); });
    track('context_home_shown', { fields: Object.keys(p).join(',') });
  }

  function escapeHTML(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ===== aansturing =====

  function apply() {
    var isProduct = document.body.classList.contains('template-product') ||
      /\/products\//.test(location.pathname);

    // De check hangt niet aan een profiel: juist wie vers uit Google binnenkomt
    // twijfelt over de maat. Daarom staat hij vóór de profielcontrole.
    if (isProduct) applyToProduct();
    if (!profile) return;

    var isCollection = !!document.querySelector('.rd-col__grid');
    var isHome = location.pathname === '/' || /^\/(en|fr)\/?$/.test(location.pathname);

    if (isCollection) {
      var hits = applyToGrid(profile);
      bar(profile, hits);
      toonCollectieTreffers(profile);
    } else if (isHome) {
      applyToHome(profile);
    }

    applyAdviceButton(profile);
  }

  // Naar buiten, zodat stylist-overlay.liquid erbij kan zodra Herman iets
  // nieuws doorgeeft.
  window.NlfContext = {
    get: function () { return profile; },
    set: function (p, sessionId) {
      if (!p || typeof p !== 'object' || Array.isArray(p)) return;
      if (!Object.keys(p).length && !profile) return; // niets te onthouden
      profile = Object.assign({}, profile || {}, p);
      if (!Object.keys(profile).length) return;
      if (sessionId) profile._session = String(sessionId).slice(0, 64);
      save(profile);
      track('context_received', { fields: Object.keys(profile).join(',') });
      apply();
    },
    erase: erase,
    apply: apply
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
